<template>
  <v-list-item :title="`Sign out ${compactUserName}`" @click="logout">
    <template #prepend>
      <v-icon :icon="mdiLogout" />
    </template>
  </v-list-item>
</template>

<script setup>
import { useUserStore } from "@/stores/user";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";
import { mdiLogout } from "@mdi/js";
import { signOutUser } from "@/api/users.service";

const user = useUserStore();
const router = useRouter();
async function logout() {
  await signOutUser(user.id);
  await user.logoutUser(router);
}

const { compactUserName } = storeToRefs(user);
</script>
